export const MODULE_NAMES = {
    BIG_QUERY: 'analytics.bigquery',
    GOOGLE_ANALYTICS: 'analytics.ganalytics',
    LOCAL_BROADCAST: 'analytics.local'
};

export const createReporter = (configuration, options) => moduleName => {
    let dependency, config = {};

    switch(moduleName) {
        case MODULE_NAMES.BIG_QUERY:
            dependency = import(/* webpackChunkName: "big_query_analytics_reporter" */ 'reporters/big_query_analytics_reporter');
            config = configuration['bigquery'];
            break;
        case MODULE_NAMES.GOOGLE_ANALYTICS:
            dependency = import(/* webpackChunkName: "google_analytics_reporter" */ 'reporters/google_analytics_reporter');
            config = configuration['google'];
            break;
        case MODULE_NAMES.LOCAL_BROADCAST:
            dependency = import(/* webpackChunkName: "local_broadcast_reporter" */ 'reporters/local_broadcast_reporter');
            break;
    }

    return dependency.then(exposeReporter).then(Reporter => new Reporter(config, options));
};

// Dynamic import provides the entire module, we only want the specific "Reporter" class for instantiation
export const exposeReporter = module => module.Reporter;